import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Switch,
    FormControlLabel
} from '@mui/material';
import { IUsuario } from '../interfaces';
import api from '../services/api';

interface UserEditProps {
    open: boolean;
    onClose: () => void;
    user: IUsuario | null;
    onSave: () => void;
}

const UserEdit: React.FC<UserEditProps> = ({ open, onClose, user, onSave }) => {
    const [formUser, setFormUser] = useState<IUsuario>({
        _id: '',
        nome: '',
        email: '',
        telefone: '',
        perfil: 'Operador',
        ativo: true,
        createdAt: ''
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setFormUser(user);
        }
    }, [user]);

    const handleSave = async () => {
        setLoading(true);
        try {
            if (formUser._id) {
                await api.put(`/api/users/${formUser._id}`, formUser);
            }
            onSave();
            onClose();
        } catch (error) {
            console.error('Erro ao salvar usuário:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Editar Usuário</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nome"
                    value={formUser.nome}
                    onChange={(e) => setFormUser({ ...formUser, nome: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="E-mail"
                    value={formUser.email}
                    onChange={(e) => setFormUser({ ...formUser, email: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Telefone"
                    value={formUser.telefone}
                    onChange={(e) => setFormUser({ ...formUser, telefone: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Perfil"
                    value={formUser.perfil}
                    onChange={(e) => setFormUser({ ...formUser, perfil: e.target.value as "Administrador" | "Operador" })}
                    fullWidth
                    margin="normal"
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={formUser.ativo}
                            onChange={(e) => setFormUser({ ...formUser, ativo: e.target.checked })}
                        />
                    }
                    label="Ativo"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
                    {loading ? 'Salvando...' : 'Salvar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserEdit;